import React from 'react';
import { AnchorSpinner } from '@anchor-ds/react';
import { AnchorSize } from '@anchor-ds/core/dist/types/global/anchor-global';
import { observer } from 'mobx-react';

import './LoadingScreen.scss';

interface Props {
  options?: {
    size: AnchorSize;
  };
}

const defaultOptions = {
  size: '72' as AnchorSize,
};

export const LoadingScreen: React.FC<Props> = observer(({ options }) => {
  const screenOptions = {
    ...defaultOptions,
    ...options,
  };

  return (
    <div className="loading-screen">
      <div className="loading-screen__spinner-wrap">
        <AnchorSpinner {...screenOptions} />
      </div>
    </div>
  );
});
